import { apiClient } from './client'
import type { ApiResponse } from './client'

export interface GameLinkedLesson {
  curriculumTitle: string
  courseTitle: string
  moduleTitle: string
  lessonTitle: string
}

export interface PublishedGameDetails {
  gameKey: string
  linkedLessons: GameLinkedLesson[]
}

export interface LessonGamePath {
  curriculumId: number
  courseId: number
  moduleId: number
  lessonId: number
}

interface LcAdminLessonGamesResponse {
  gameKeys: string[]
}

export const gameApi = {
  getPublishedKeys: async (): Promise<string[]> => {
    const response = await apiClient.get<ApiResponse<string[]>>('/games/published')
    return response.data.data ?? []
  },

  getPublishedDetails: async (): Promise<PublishedGameDetails[]> => {
    const response = await apiClient.get<ApiResponse<PublishedGameDetails[]>>('/games/published/details')
    return response.data.data ?? []
  },

  getAdminGamesByLessonPath: async (path: LessonGamePath): Promise<string[]> => {
    const response = await apiClient.get<ApiResponse<LcAdminLessonGamesResponse>>(
      '/lc/admin/games/by-lesson-path',
      {
        params: {
          curriculumContentId: path.curriculumId,
          courseContentId: path.courseId,
          moduleContentId: path.moduleId,
          lessonContentId: path.lessonId,
        },
      },
    )
    return response.data.data?.gameKeys ?? []
  },
}
